export const FALLBACK_EVENTS = [
  { id: '', date: '' },
  { id: '', date: '' },
  { id: '', date: '' },
  { id: '', date: '' },
  { id: '', date: '' },
  { id: '', date: '' }
]

// Define the translation map
export const translationSeasonMap = {
  'REG': 'sm_regular',
  'PST': 'sm_post_season',
  'PIT': 'sm_play_in_tournament',
  'IST': 'sm_in_season_tournament'
  // Add more mappings as needed
}